import {createStore, applyMiddleware, compose} from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "../reducers";
import rootSaga from "../sagas";

const configureStore = () => {
	const sagaMiddleware = createSagaMiddleware();
	const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
	const middlewares = process.env.NODE_ENV === "production" ?
		applyMiddleware(sagaMiddleware) :
		composeEnhancers(applyMiddleware(sagaMiddleware));

	return {
		...createStore(rootReducer, middlewares)
		,
		runSaga: sagaMiddleware.run(rootSaga)
	};
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/js/store/configureStore.js